import { FilmTile } from "@components/film/FilmTile"
import { EventType } from "@generated-types"
import { defineBlock } from "eddev/blocks"
import { useHydrating } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Related Films",
  icon: "video-alt3",
  tags: ["film-root"],
}

export default defineBlock("film/film-related", (props) => {
  const hydrating = useHydrating()

  const films = [
    ...(props.overrideFilms?.map((item) => item?.film!).filter(Boolean) ?? []),
    ...(props.film?.relatedFilms?.filter(Boolean).filter((item) => item?.eventInfo?.eventType !== EventType.Short) ??
      []),
  ].slice(0, 4)

  if (hydrating) return null

  if (films.length === 0 && !env.admin) {
    return null
  }

  return (
    <div className="my-10" data-nosnippet data-mixpanel-area="Related Films">
      <div className="grid-auto">
        <div className="col-span-12">
          <h3 className="type-title-m mb-5">If you like this, you might like...</h3>
        </div>
        <div className="col-span-12 grid-auto gap-y-8">
          {films.map((film) => (
            <div key={film?.uri} className="col-span-6 md:col-span-3">
              <FilmTile film={film!} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
})
